import initDeleteSelectedDocementsHandler from './parts/delete-selected-documents-handler';
import initClearDocumentsTable from './parts/clear-documents-table-handler';
const initAdminScripts = () => {
    initClearDocumentsTable();
    initDeleteSelectedDocementsHandler();
};
document.addEventListener('DOMContentLoaded', initAdminScripts);
